import { useUnsafeMemo } from 'modules/core/hooks/useMemo'
import { useNavigation } from 'modules/core/hooks/useNavigation'

import { Settings } from 'modules/settings/lib/settings'

export const useSearchSettings = (search: string, settings: Settings[]) => {
  const { navigation } = useNavigation()

  return useUnsafeMemo(() => {
    return settings
      .map((settingCategory) => {
        const children = settingCategory.children
          .filter((setting) => ('hidden' in setting && !setting.hidden) || !('hidden' in setting))
          .filter((setting) => {
            return [
              setting.title.toLowerCase(),
              setting.description.toLowerCase(),
              (('keywords' in setting ? setting.keywords : []) ?? []).toString().toLowerCase(),
              settingCategory.title.toLowerCase(),
            ].find((term) => term.includes(search.toLowerCase()))
          })

        return { ...settingCategory, children }
      })
      .filter((settingCategory) => settingCategory.children.length > 0)
  }, [search, settings, navigation])
}
